import {
	Box,
	Flex,
	Text,
	ThemeColorVariable,
	ThemeFontSizeVariable,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";

import { formatDateByLocale, formatDateString } from "../../utils/date-helper";
import { SalaryItem as SalaryItemDTO } from "../../models/dto/salary/salary-item";
import { addMonths } from "date-fns";
import { useFile } from "../../hooks/use-file";
import { QueryKeys } from "../../types/query-key-enum";
import { getSalaryPdf } from "../../services/api/salary-api";

type SalaryItemProps = {
	salary: SalaryItemDTO;
};

const SalaryItem = (props: SalaryItemProps) => {
	const { salary } = props;

	const { openFile } = useFile<SalaryItemDTO>({
		queryKey: (salary) => [
			QueryKeys.SalaryPdf,
			salary ? addMonths(salary.reportDate, -1) : "",
			salary?.system,
		],
		queryFn: (salary) => async () => {
			const file = await getSalaryPdf(salary.system, addMonths(salary.reportDate, -1));
			const fileName = `${salary.systemName.replaceAll("/", "-")} ${formatDateString(salary.reportDate, "yyyy-MM-dd")}.pdf`;
			return new File([file], fileName, {
				type: file.type,
			});
		},
	});

	return (
		<Box
			data-testid="salary-item"
			onClick={() => {
				openFile(salary);
			}}
		>
			<Flex
				direction="row"
				alignItems={"center"}
				justifyContent={"space-between"}
				mt={ThemeSpaceVariable.Small}
			>
				<Text fontSize={ThemeFontSizeVariable.Large}>{salary.title}</Text>
				<Text color={ThemeColorVariable.OnBackgroundSubdued} fontSize={ThemeFontSizeVariable.Small}>
					{formatDateByLocale(salary.reportDate, "medium")}
				</Text>
			</Flex>
			<Text fontSize={ThemeFontSizeVariable.Small} color={ThemeColorVariable.OnBackgroundSubdued}>
				{salary.systemName}
			</Text>
		</Box>
	);
};

export default SalaryItem;
